export default "__VITE_ASSET__B9aSW03___"